module.exports = __webpack_public_path__ + "static/img/jiangmei.32fbd60.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/coopera/images/jiangmei.png
// module id = 83G2
// module chunks = 1